<div class="login-subcontainer">
  <div class="login-panel-left">
    <div class="forgot-username">
      <div class="login-panel-header">
        <img class="login-panel-icon" src="assets/images/lock.svg" alt="forgot username" />
        <span class="forgot-username-text">{{ "userprofile.label.forgotMy" | translate }}
          <span class="username"> {{
            "userprofile.label.forgot.username" | translate }}
          </span>
        </span>

        @if(emailSent){
        <div class="success-panel">
          <img class="icons-check-circle" src="assets/images/check-circle.svg" alt="Success" />
          <p class="success">{{ "userprofile.text.forgotUsername.confirmation" | translate }}</p>
        </div>
        }@else {
        <p class="forgot-instructions" [innerHTML]="'userprofile.text.forgotUsername.instructions' | translate"></p>
        }
      </div>

      <div class="email-form">

        @if (errors.length > 0) {
        <div class="notification-bar" role="alert" aria-live="assertive">
          <div class="login-error">
            <img class="icons-alert-circle" src="assets/images/alert-circle.svg" alt="Error" />
            <div class="message">
              @for (error of errors; track $index) {
              <li style="list-style: none" [innerHTML]="error"></li>
              }
            </div>
          </div>
        </div>
        }
        <form (ngSubmit)="submit()" [formGroup]="forgotUsernameForm">
          <div class="form-field">
            <app-standard-form-field label="userprofile.label.email" controlName="emailAddress" inputId="emailAddress"
              [parentForm]="forgotUsernameForm" [disabled]="emailSent">
            </app-standard-form-field>

            @if(emailSent) {
            <button class="forgot-password-button" type="button" [routerLink]="UrlConstants.forgotPasswordUrl"
              [queryParams]="{ email: emailAddress }">
              {{ 'userprofile.label.forgotMyPassword' | translate }}
            </button>
            } @else {
            <button class="login-submit" [ngClass]="{
                        'disabled-login-submit': loading,
        }" type="submit" [disabled]="loading" [value]="'general.label.button.submit' | translate">
              @if (loading) {
              <img class="login-loading-gif" src="assets/images/loading_new.gif" alt="Loading" />
              } @else {
              {{ "general.label.button.submit" | translate }}
              }
            </button> }

          </div>
        </form>
      </div>
    </div>
    <div class="mt-3">
      <a class="returnToLogin" [routerLink]="UrlConstants.loginUrl"
        [innerHTML]="'general.label.returnToLogin' | translate"></a>
    </div>
  </div>
  <img class="right-panel" src="assets/images/CRC-Login-Image.jpg" alt="Login background" />
</div>